import { EUserType } from '@app/core/enum/client.enum'
import { PERMISSIONS } from '@app/core/constants/permissions.constants'
import { PermissionService } from '@core/services/permission-service/permission-service'

/**
 * Determine user role from permission service.
 * RM if has VIEW_MY_LEAD permission.
 * ZM if has VIEW_TEAM_LEADS permission (higher priority).
 * Team pipeline / unassigned clients visibility: VIEW_TEAM_LEADS and ReporteesService.hasReportees (both required).
 * VIEW_TEAM_LEADS may be granted to any role; reportees ensure there is a team to show.
 * Returns null when permissions are missing/empty or when neither permission is enabled.
 */
export async function determineUserRoleFromPermissions(
    permissionService: PermissionService,
): Promise<EUserType | null> {
    try {
        const permissions = await permissionService.getPermissionsBitwise()

        if (!permissions || !Array.isArray(permissions) || !permissions.length) {
            return null
        }

        const hasViewTeamLeads = permissionService.getPermissionByName(PERMISSIONS.VIEW_TEAM_LEADS)
        const hasViewMyLead = permissionService.getPermissionByName(PERMISSIONS.VIEW_MY_LEAD)

        if (hasViewTeamLeads) {
            return EUserType.ZM
        }
        if (hasViewMyLead) {
            return EUserType.RM
        }
        return null
    } catch {
        return null
    }
}
